// Keeps <head> in step with in-app navigation. The served HTML for each route is already
// correct (scripts/prerender.js); this only matters once the SPA changes routes itself.
import {useEffect} from "react";
import SEO from "./pages.json";

const byPath = Object.fromEntries(SEO.pages.map((p) => [p.path, p]));

function setTag(selector, create, value) {
    let el = document.head.querySelector(selector);
    if (!el) {
        el = create();
        document.head.appendChild(el);
    }
    el.setAttribute(el.tagName === "LINK" ? "href" : "content", value);
}
const metaEl = (attr, key) => () => {
    const el = document.createElement("meta");
    el.setAttribute(attr, key);
    return el;
};
const setMeta = (name, value) => setTag(`meta[name="${name}"]`, metaEl("name", name), value);
const setProp = (prop, value) => setTag(`meta[property="${prop}"]`, metaEl("property", prop), value);

export function useRouteMeta(pathname) {
    useEffect(() => {
        const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
        const page = byPath[path];
        if (!page) return;   // unknown routes keep whatever the served HTML had
        const url = path === "/" ? `${SEO.site}/` : SEO.site + path;
        document.title = page.title;
        setMeta("description", page.description);
        setTag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), {rel: "canonical"}), url);
        setProp("og:title", page.title);
        setProp("og:description", page.description);
        setProp("og:url", url);
        setProp("og:image", page.image || SEO.defaultImage);
    }, [pathname]);
}
